<template>
  <dropdown

    v-model="dropdownOptions.value"
    class="search-input"
    v-bind="dropdownOptions"
  >
    <div class="search-input__trigger" />


    <input
      ref="inputElement"
      v-bind="$attrs"
      type="text"
      name="name"
      autocomplete="off"
      class="form-control no_border m-b-0 p-r-3"
      :value="value"
      @click.prevent
      @keydown.prevent.down="selectNext"
      @keydown.prevent.up="selectPrev"
      @keydown.prevent.enter="onKeySelect"
      @keydown.prevent.tab="onKeySelect"
      @input="$emit('input', $event.target.value)"
      @blur="hidePopover"
    >

    <template slot="dropdown">
      <div class="rb-tags-input">
        <ul
          ref="dropdownList"
          class="dropdown"
        >
          <li
            v-for="(item, index) in filteredDatalist"
            :key="index"
            class="uib-typeahead-match"
            :class="{active: index === activeIndex}"
            role="option"
          >
            <a
              draggable="false"
              href=""
              tabindex="-1"
              class="ng-binding ng-scope"
              :title="item"
              @click.prevent="$emit('input', item)"
            >
              {{ item }}
            </a>
          </li>
        </ul>
      </div>
    </template>
  </dropdown>
</template>

<script>
import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch
} from 'vue';
import { Dropdown } from 'uiv';
export default defineComponent({
  inheritAttrs: false,
  components: {
    Dropdown
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * List of autocomplete input values
     */
    datalist: {
      type: Array,
      required: true
    }
  },
  setup(props, ctx) {
    const input = reactive({
      text: null
    });

    const inputElement = ref();

    const showPopup = ref(false);


    /**
     * Filtered list based on input value
     */
    const filteredDatalist = computed(() => {
      let _list = props.datalist;
      if(_list && Array.isArray(_list)) {
        if(String(input.text).length) {
          _list = _list.filter(k => String(k).toLowerCase().includes(props.value));
        }
      }

      _list.splice(10);

      if(Array.isArray(_list) && !_list.includes(props.value)) {
        _list.push(props.value);
      }

      return _list;
    });

    const activeIndex = ref(0);
    const selectedValue = computed(() => filteredDatalist.value[activeIndex.value]);


    /**
     * Watch for when value changes
     */
    watch(
      () => props.value,
      (newV, oldV) => {
        activeIndex.value = 0;
        if (newV) {
          showPopup.value = true;
        } else {
          if (!newV?.length) {
            showPopup.value = false;
          }
        }
      },
      {
        flush: 'sync'
      }
    );

    async function onKeySelect(ev) {
      ctx.emit('input', selectedValue.value);
      ctx.emit('change', selectedValue.value);
      await this.$nextTick();
      showPopup.value = false;
    }

    /** @type {IDropdownOptions} */
    const _dropdownOptions = {
      value: showPopup,
      appendToBody: true,
      dropup: false,
      tag: 'div'
    };

    const dropdownOptions = reactive(_dropdownOptions);

    return {
      input,
      dropdownOptions,
      inputElement,
      filteredDatalist,
      activeIndex,
      selectedValue,
      onKeySelect
    };
  },
  methods: {
    selectPrev() {
      this.activeIndex === 0
        ? this.activeIndex = this.filteredDatalist.length -1
        : this.activeIndex--;
    },
    selectNext() {
      this.activeIndex = (this.activeIndex + 1) % this.filteredDatalist.length;
    },
    hidePopover(ev) {
      if(!this.$refs.dropdownList.contains(ev.relatedTarget)) {
        this.dropdownOptions.value = false;
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.search-input {
  position: relative;
}

.uib-typeahead-match {
  &.active,
  &:hover {
    background-color: var(--component-autocomplete__item--selected-bg-color);
    color: var(--component-autocomplete__item--selected-text);
  }


  a {
    display: block;
    color: inherit;
        padding: 3px 15px !important;
    font-size: 12px;
    text-decoration: none;

    &,
    &:hover,
    &:focus,
    &:active {
      outline: 0;
    }
  }
}
</style>
